export const helplist = [

  {
    title: 'Aprende a usar Basys',
    lista1: {
      text: '1. Introducción a Basys.',
      href: '/help_center/introduction'
    },
    lista2: {
      text: '2. Catálogo de productos y servicos.',
      href: '#'
    },
    lista3: {
      text: '3. Clientes.',
      href: '#'
    },
    lista4: {
      text: '4. Documentos comerciales de venta: Presupuestos, pedidos y albaranes de venta.',
      href: '#'
    },
    lista5: {
      text: '5. Facturación.',
      href: '#'
    },
    lista6: {
      text: '6. Compras y gastos.',
      href: '#'
    },
    lista7: {
      text: '7. Informes',
      href: '#'
    },
    lista8: {
      text: '8. Cómo empezar a usar tu software.',
      href: '#'
    },
    lista9: {
      text: '',
      href: '#'
    }

  },
  {
    title: 'Configuración',
    lista1: {
      text: '1. Cómo hacer facturas con vencimientos.',
      href: '#'
    },
    lista2: {
      text: '2. Cómo importar y actualizar el precio de tus diferentes tarifas.',
      href: '#'
    },
    lista3: {
      text: '3. Cómo exportar clientes y productos a Excel.',
      href: '#'
    },
    lista4: {
      text: '4. Cómo importar clientes y productos.',
      href: '#'
    },
    lista5: {
      text: '5. Cómo configurar el correo electrónico.',
      href: '#'
    },
    lista6: {
      text: '6. Crear usuarios.',
      href: '#'
    },
    lista7: {
      text: '7. Cómo crear familias de productos o de clientes.',
      href: '#'
    },
    lista8: {
      text: '',
      href: '#'
    },
    lista9: {
      text: '',
      href: '#'
    }
  },
  {
    title: 'Facturacion electrónica CFDI',
    lista1: {
      text: '1. CFDI de traslado como complemento Carta Porte.',
      href: '#'
    },
    lista2: {
      text: '2. Cancelación de CFDI de facturación con motivo.',
      href: '#'
    },

    lista3: {
      text: '3. Cómo hacer una factura CFDI 3.3',
      href: '#'
    },
    lista4: {
      text: '4. Cancelación de CFDI de REP.',
      href: '#'
    },
    lista5: {
      text: '5. Sustitución de CFDIs cancelados.',
      href: '#'
    },
    lista6: {
      text: '6. Emitir un CFDI sin cobrar como PUE.',
      href: '#'
    },
    lista7: {
      text: '7. Emisión de un único CFDI de Rep de pagos Múltiples.',
      href: '#'
    },
    lista8: {
      text: '8. Unión de campos "Nombre" y "Descripción" para aumentar en número de caracteres trasladados al CFDI',
      href: '#'
    },
    lista9: {
      text: '9. Emisión de CFDI 3.3 de anticipo y su aplicación en CFDI de Ingreso por remanente de contraprestación.',
      href: '#'
    }
  },
  {
    title: 'Aprende a usar Basys',
    lista1: {
      text: '1. CRM online: Clientes.',
      href: '#'
    },
    lista2: {
      text: '2. Cómo guardar información de los clientes.',
      href: '#'
    },
    lista3: {
      text: '3. Cómo organizar datos de clientes: Familias.',
      href: '#'
    },
    lista4: {
      text: '4. Asignación de clientes a miembros de la empresa.',
      href: '#'
    },
    lista5: {
      text: '5. Dirección de clientes.',
      href: '#'
    },
    lista6: {
      text: '6. Cómo contabilizar entregas a cuantas de clientes.',
      href: '#'
    },
    lista7: {
      text: '',
      href: '#'
    },
    lista8: {
      text: '',
      href: '#'
    },
    lista9: {
      text: '',
      href: '#'
    }
  }

]
